<template>
    <div class="row">
        <div class="col-12">
            <p class="card-subtitle mb-3">
                A continuación puede encontrar una lista de franjas horarias disponibles para el nombre del servicio por nombre del empleado
                <br>
                Seleccionar franja horaria para reservar
                <br>
                Hora de la cita*
            </p>
        </div>
        <div class="col-12">
            <div class="form-control">
              <div class="row">
                <div class="col-3 text-center mb-3" v-for="(item, index) in times" :key="index">
                  <button v-if="notimes.findIndex((e) => e == item.id) !== -1" type="button" disabled class="btn btn-dark">{{ item.start_time }} - {{ item.end_time }}</button>
                  <button v-else type="button" class="btn" :class="data.schedule_id === item.id ? 'btn-primary' : 'btn-light'" @click="onActive(item.id, item.start_time + ' - ' + item.end_time)">{{ item.start_time }} - {{ item.end_time }}</button>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      times: [],
      notimes: [],
      time: -1,
      submit: null
    }
  },
  created () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      this.submit = 'table'
      this.$axios({
        url: '/all/schedules?date=' + this.data.date,
        method: 'GET'
      })
        .then((resp) => {
          this.times = resp.data.times
          this.notimes = resp.data.notimes
        })
        .finally((resp) => {
          this.submit = null
        })
    },
    onActive: function (index, time) {
      this.data.schedule_id = index
      this.data.time = time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/Time.vue